// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/9d813d14/" + chunkId + "." + __webpack_require__.h() + ".v9d813d14.js";
};